import { Layout, Button, Input, Form, Row, Col, Spin, Radio } from 'antd';
import { useState, createRef, useEffect, useContext } from 'react';
import ReactJson from 'react-json-view'
import 'antd/dist/antd.css';
import './App.css';
import ChartView from './ChartView'
import RelView from './RelView'
import TreeView from './TreeView'
import { DataCenterContext } from './DataCenter';
import DocEventView from './DocEventView';

const { Header, Content } = Layout;

const layout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 18 },
};


function InputView({ submit }) {
  const [{ text }, update] = useContext(DataCenterContext)
  return <Form
    initialValues={text}
    size="large"
    onFinish={submit}
    onValuesChange={newtext => console.log(newtext)||update({ text: { ...text, ...newtext } })}
    {...layout}>
    <Form.Item name="title" label="文章标题">
      <Input />
    </Form.Item>
    <Form.Item name="content" label="文章内容">
      <Input.TextArea autoSize={{ minRows: 8, maxRows: 25 }} showCount={true} />
    </Form.Item>
    <Form.Item wrapperCol={{ offset: 11, span: 12 }}>
      <Button type="primary" style={{ borderRadius: 10 }} htmlType="submit">分析</Button>
    </Form.Item>
  </Form>
}

function SentenceMark({ sentences, words, graphContext }) {
  const spans = words
    .map(({ spans, type, id }) => spans.map(span => [...span, type, id]))
    .flat()
    .sort((a, b) => a[0] - b[0] || a[1] - b[1])
    .reduce((acc, cur) => {
      const last = acc[acc.length - 1]
      if (last && last[1] > cur[0]) {
        last[1] = cur[1]
        last[2] = cur[2]
        last[3] = cur[3]
      } else {
        acc.push(cur)
      }
      return acc
    }, [])
  const res = []
  let i = 0
  sentences.forEach(({ span: [start_s, end_s], content, id }) => {
    let ram = 0
    const ret = []
    while (i < spans.length) {
      const [start, end, type, word] = spans[i]
      if (start < start_s || end_s < end) {
        break
      }
      ret.push(content.substring(ram, start - start_s))
      ret.push(<span style={{
        backgroundColor: global.colorMap[type],
        fontWeight: 'bolder'
      }} key={i} onClick={() => {
        const { graph, apis } = graphContext?.current
        graph.emit('node:click', { item: graph.findById(word) })
        apis.focusNodeById(word)
      }}>{
          content.substring(start - start_s, end - start_s)
        }</span>)
      ram = end - start_s
      i++
    }
    ret.push(content.substring(ram))
    res.push(<p id={`sentence${id}`} key={id}>{ret}</p>)
  })
  return <div>{res}</div>
}

export function SentenceRaw({ sentences }) {
  return <div>{sentences.map(({ id, content }) => <p id={`sentence${id}`} key={id}>{content}</p>)}</div>
}

const planes = {
  input: {
    name: '文本输入',
  },
  sentseg: {
    name: '分句',
    data(sentences) {
      return sentences
    }
  },
  wordseg: {
    name: '分词',
    data(sentences) {
      return sentences.map(({ id, pos }) => ({ id, content: pos.map(([w]) => w).join(' ') }))
    }
  },
  posseg: {
    name: '词性标注',
    data(sentences) {
      return sentences.map(({ id, pos }) => ({ id, content: pos.map(([w, f]) => `${w}\\${f}`).join(' ') }))
    }
  },
  entities: {
    name: '实体抽取',
  },
  keywords: {
    name: '关键词抽取',
  },
  relation_open: {
    name: '开放关系抽取',
  },
  sent_structure: {
    name: '句子结构分析',
  },
  doc_event: {
    name: '文档事件抽取',
  },
  json: {
    name: 'JSON数据',
  },
}

function App() {
  const [data, update] = useContext(DataCenterContext);
  const [loading, setLoading] = useState(false);
  const graphRef = createRef()
  const relTabs = ['entities', 'keywords', 'relation_open']
  const chartTabs = ['sentseg', 'wordseg', 'posseg']
  planes.input.render = () => <Col span={24} style={{
    height: '100%',
    overflow: 'auto'
  }}><InputView submit={submit} /></Col>
  relTabs.forEach(key => planes[key].render = () => <>
    <Col span={10} style={{
      height: '100%',
      overflow: 'auto'
    }}><SentenceMark sentences={data.sentences} words={data[key].words} graphContext={graphRef} /></Col>
    <Col span={14} style={{
      height: '100%',
      overflow: 'auto'
    }}><RelView graph={data[key]} sentences={data.sentences} ref={graphRef} /></Col>
  </>)
  chartTabs.forEach(key => planes[key].render = () => <>
    <Col span={10} style={{
      height: '100%',
      overflow: 'auto'
    }}><SentenceRaw sentences={planes[key].data(data.sentences)} /></Col>
    <Col span={14} style={{
      height: '100%',
      overflow: 'auto'
    }}><ChartView {...data} /></Col>
  </>)
  planes.sent_structure.render = () => <TreeView {...data} />
  planes.doc_event.render = () => <DocEventView {...data} />
  planes.json.render = () => <Col span={12} style={{
    height: '100%',
    overflow: 'auto'
  }}>
    <div style={{ float: 'right' }}>
      <Button
        style={{ zIndex: 1001 }}
        href={'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(data))}
        download={`${data.text.title}.json`}
      >导出数据</Button>
      <Button
        style={{ zIndex: 1001 }}
        onClick={() => {
          const file = document.createElement('input')
          file.type = 'file'
          file.onchange = function () {
            const reader = new FileReader()
            reader.readAsText(file.files[0])
            reader.onload = function () {
              update(JSON.parse(this.result))
            };
          }
          file.click()
        }}
      >导入数据</Button>
    </div>
    <ReactJson style={{ fontSize: 16 }} src={data} collapsed={1} />
  </Col>
  function submit(data) {
    console.log(JSON.stringify(data))
    setLoading(true)
    fetch('/news_process', {
      method: 'POST',
      headers: {
        'content-type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(data)
    }).then(resp => resp.status === 200 ? resp.json() : false)
      .catch(console.log)
      .then(data => {
        setLoading(false)
        if (data) {
          const ds = d => d.words.flatMap(cur => cur.spans.map(span => [...span, cur.id])).sort(([al, ar], [bl, br]) => al - bl || ar - br)
          const dd = d => d.words.reduce((rem, cur) => {
            rem[cur.id] = cur
            return rem
          }, {})
          const addCoref = (sent, coref, open_spans) => {
            let offset = 0
            const spans = sent.flatMap(({ pos }) => pos.map(([cur]) => ([offset, offset += cur.length])))
            const open_map = open_spans.reduce((rem, [l, r, id]) => rem.set(`${l},${r}`, id), new Map())
            const coref_spans = coref.map(cur => cur.map(([l, r]) => (`${spans[l][0]},${spans[r][1]}`)))
            console.log(open_map, coref_spans);
            coref_spans.forEach(set => {
              for (let i = 0; i < set.length; i++) {
                for (let j = i + 1; j < set.length; j++) {
                  if (!open_map.has(set[i]) || !open_map.has(set[j])) {
                    continue
                  }
                  const source = open_map.get(set[i])
                  const target = open_map.get(set[j])
                  if (source === target) {
                    continue
                  }
                  data.relation_open.relations.push({
                    source, target, type: 'coref'
                  })
                }
              }
            })
          }
          const open_spans = ds(data.relation_open)
          const xlink_spans = ds(data.xlink)
          const open_dict = dd(data.relation_open)
          const xlink_dict = dd(data.xlink)
          const tmp_rel = []
          console.log(data.relation_open);
          console.log(open_spans);
          console.log(open_dict);
          addCoref(data.sentences, data.coref, open_spans)
          for (let oi = 0, xi = 0; oi < open_spans.length && xi < xlink_spans.length;) {
            const [ol, or, oid] = open_spans[oi]
            const [xl, xr, xid] = xlink_spans[xi]
            if (ol === xl && or === xr) {
              open_dict[oid].info = xlink_dict[xid].info
            } else if (ol <= xl && xr <= or) {
              const degree = xlink_dict[xid].degree || 0
              xlink_dict[xid].degree = degree + 1
              xlink_dict[xid].spans = []
              tmp_rel.push({
                source: xid,
                target: oid,
                type: 'occur_in'
              })
            }
            if (xl <= or) {
              xi += 1
            } else {
              oi += 1
            }
          }
          data.relation_open.words.push(...Object.values(xlink_dict).filter(item => item.degree > 0))
          data.relation_open.relations.push(...tmp_rel.filter(({ source, target }) => xlink_dict[source]?.degree > 0 || xlink_dict[target]?.degree > 0))
          console.log(data);
          update({
            tabKey: 'sentseg',
            ...data
          })
        }
      })
  }
  useEffect(() => {
    const cname = 'newsID'
    const value = document.location.href.match(new RegExp(`[?].*${cname}=(.*?)(&|$)`))
    if (!value) return
    submit({ newsID: value[1] })
  }, [])
  return <Spin spinning={loading} tip="文本处理中……">
    <Layout>
      <Header style={{
        backgroundColor: '#40a9ff',
        color: '#F9F9F9',
        height: 80,
        fontSize: 28,
        // position: 'fixed',
        lineHeight: '80px'
      }}>
        <span>NewsMiner单篇新闻处理 - {planes[data.tabKey].name}</span>
      </Header>
      <Content style={{
        backgroundColor: '#e6f7ff',
        padding: '16px 64px 64px',
        height: 'calc(100vh - 80px)'
      }}>
        <Radio.Group size="large"
          onChange={e => update({ tabKey: e.target.value })}
          style={{ marginBottom: 16 }}
          value={data.tabKey}
          buttonStyle="solid">
          {Object.keys(planes).map(e =>
            <Radio.Button key={e} value={e}>{planes[e].name}</Radio.Button>
          )}
        </Radio.Group>
        <Row id="main-panel" gutter={32} style={{
          backgroundColor: '#ffffff',
          height: 'calc(100% - 56px)',
          borderRadius: 10,
          padding: 32,
        }}>{planes[data.tabKey].render()}</Row>
      </Content>
    </Layout>
  </Spin>
}

export default App;
